import React, { useState } from "react";
import { Fragment } from "react";
import {
  Button,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
  Tooltip,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { CHANGE_PASSWORD } from "../../../constants/ApiPaths";
import { getAdminEmail } from "../../common/CommonFunctions";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import Iconawesomeeye from "../../../images/Iconawesomeeye.svg";
import Iconionicmdeyeoff from "../../../images/Iconionicmdeyeoff.svg";
import { Info } from "../../common/Info";

export default function ChangePassword() {
  const [oldPasswordShown, SetOldPasswordShown] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmpasswordShown, setconfirmPasswordShown] = useState(false);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const oldTogglePassword = () => {
    SetOldPasswordShown(oldPasswordShown ? false : true);
  };

  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const confirmTogglePassword = () => {
    setconfirmPasswordShown(confirmpasswordShown ? false : true);
  };

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    oldPassword: Yup.string().trim().required("Password is required"),
    newPassword: Yup.string().trim().required("New Password Required"),
    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .test("passwords-match", "Password mismatch", function (value) {
        return this.parent.newPassword === value;
      }),
  });
  const saveFormValues = async (values) => {
    setLoading(true);
    const config = {
      method: "PUT",
      url: CHANGE_PASSWORD,
      data: {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
        email: getAdminEmail(),
        hyperlink: window.location.host,
      },
      headers: authHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;

      if (status === "Success") {
        resetForm({});
        CustomAlertMessage(
          "Password changed successfully!",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };
  //Formik
  const { handleSubmit, handleChange, resetForm, values, errors, touched } =
    useFormik({
      initialValues: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      validationSchema,
      onSubmit: (values) => saveFormValues(values),
    });
  return (
    <Fragment>
      <div className="page">
        <Form form="true" onSubmit={handleSubmit}>
          <Row>
            <Col sm="12">
              <p>
                Change Password{" "}
                <Tooltip
                  isOpen={id === "changepassword" && tooltipOpen}
                  target={"changepassword"}
                  toggle={() => toggle("changepassword")}
                >
                  Enter in information to change account password
                </Tooltip>
                <span id={"changepassword"}>
                  <Info />
                </span>
              </p>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label for="oldPassword">Old Password</Label>
                <InputGroup>
                  <Input
                    type={oldPasswordShown ? "text" : "password"}
                    name="oldPassword"
                    id="oldPassword"
                    value={values.oldPassword}
                    invalid={
                      errors.oldPassword && touched.oldPassword ? true : false
                    }
                    onChange={handleChange}
                    placeholder="Enter Old Password"
                  />
                  <>
                    <InputGroupText
                      onClick={oldTogglePassword}
                      style={{ cursor: "pointer" }}
                    >
                      {oldPasswordShown ? (
                        <img src={Iconawesomeeye} alt=""/>
                      ) : (
                        <img src={Iconionicmdeyeoff} alt=""/>
                      )}
                    </InputGroupText>
                  </>
                  <FormFeedback>
                    {errors.oldPassword && touched.oldPassword
                      ? errors.oldPassword
                      : ""}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="newPassword">New Password</Label>
                <InputGroup>
                  <Input
                    type={passwordShown ? "text" : "password"}
                    name="newPassword"
                    id="newPassword"
                    placeholder="Enter New Password"
                    value={values.newPassword}
                    invalid={
                      errors.newPassword && touched.newPassword ? true : false
                    }
                    onChange={handleChange}
                  />
                  <>
                    <InputGroupText
                      onClick={togglePassword}
                      style={{ cursor: "pointer" }}
                    >
                      {passwordShown ? (
                        <img src={Iconawesomeeye} alt=""/>
                      ) : (
                        <img src={Iconionicmdeyeoff} alt="" />
                      )}
                    </InputGroupText>
                  </>
                  <FormFeedback>
                    {errors.newPassword && touched.newPassword
                      ? errors.newPassword
                      : ""}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="confirmPassword">Confirm Password</Label>
                <InputGroup>
                  <Input
                    type={confirmpasswordShown ? "text" : "password"}
                    name="confirmPassword"
                    id="confirmPassword"
                    value={values.confirmPassword}
                    invalid={
                      errors.confirmPassword && touched.confirmPassword
                        ? true
                        : false
                    }
                    onChange={handleChange}
                    placeholder="Enter Confirm Password"
                  />
                  <>
                    <InputGroupText
                      onClick={confirmTogglePassword}
                      style={{ cursor: "pointer" }}
                    >
                      {confirmpasswordShown ? (
                        <img src={Iconawesomeeye} alt=""/>
                      ) : (
                        <img src={Iconionicmdeyeoff} alt=""/>
                      )}
                    </InputGroupText>
                  </>
                  <FormFeedback>
                    {errors.confirmPassword && touched.confirmPassword
                      ? errors.confirmPassword
                      : ""}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
              {/* button */}
              <div className="top-btn">
                <Button type="submit" color="primary">
                  {loading && <CustomButtonLoader loading={loading} />}
                  Save Changes
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </Fragment>
  );
}
